import React, { useState, useEffect } from 'react';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/announcement/AddAnnouncementModal.css';
import Upload from '../../shared/PdfUpload';
import message from '../../../data/Message.json';
import { hours, minute } from '../../../data/hoursAndMinute';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { UPDATEANNOUNCEMENT_ENDPOINT, ALLPORTTERMINALS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import SubmitModal from '../../shared/SuccessModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
const EditModal = props => {
  const getTimeEdit = (timeStamp) => {
    return new Date(Number(timeStamp)).toString().split(' ')[4].substring(0, 5);
  }
  const getDateEdit = (timeStamp) => {
    let date = new Date(Number(timeStamp)).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  const [showEffectiveCalendar, setShowEffectiveCalendar] = useState(false);
  const [showExpiryCalendar, setShowExpiryCalendar] = useState(false);
  const [dropDownEffectiveMinute, setDropDownEffectiveMinute] = useState(false);
  const [dropDownExpiryMinute, setDropDownExpiryMinute] = useState(false);
  const [dropDownEffectiveHour, setDropDownEffectiveHour] = useState(false);
  const [dropDownExpiryHour, setDropDownExpiryHour] = useState(false);
  const container = React.createRef();
  const indexValue = props.editIndex;
  const announcementData = props.announcementData;
  const [textmessage, setTextmessage] = useState(announcementData[indexValue]?.text)
  const [aCategory, setACategory] = useState(announcementData[indexValue]?.announcementCategory);
  const [effectiveDateValue, setEffectiveDateValue] = useState(getDateEdit(announcementData[indexValue].announcementFrom));
  const [expiryDateValue, setExpiryDateValue] = useState(getDateEdit(announcementData[indexValue].announcementTo));
  const [effectiveDateHourValue, setEffectiveDateHourValue] = useState(getTimeEdit(announcementData[indexValue]?.announcementFrom).split(':')[0]);
  const [effectiveDateMinuteValue, setEffectiveDateMinuteValue] = useState(getTimeEdit(announcementData[indexValue]?.announcementFrom).split(':')[1]);
  const [expiryDateHourValue, setExpiryDateHourValue] = useState(getTimeEdit(announcementData[indexValue]?.announcementTo).split(':')[0]);
  const [expiryDateMinuteValue, setExpiryDateMinuteValue] = useState(getTimeEdit(announcementData[indexValue]?.announcementTo).split(':')[1]);
  const publishDateTime = new Date();
  const [terminalDropDown, setTerminalDropDown] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [terminalSelectStatus, setTerminalSelectStatus] = useState({});
  const [pdfUploadLink, setPdfUploadLink] = useState(announcementData[indexValue]?.attachment);
  const [selectedTerminalsName, setSelectedTerminalsName] = useState("- - Select - -");
  const [portData, setPortData] = useState([]);
  const pdfLink = announcementData[indexValue]?.attachment.split('/')[11]?.split("'")[0];
  const isUploadDisabled = announcementData[indexValue]?.attachment.length > 0 ? true : false;
  const calendarOneCopy = announcementData[indexValue].announcementFrom;
  const calendarTwoCopy = announcementData[indexValue].announcementTo;
  const selectedTerminal = announcementData[indexValue]?.ports;
  const [checked, setChecked] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [expiryDateHours, setExpiryDateHours] = useState([]);
  const [expiryDateMinutes, setExpiryDateMinutes] = useState([]);
  const [textLimit, setTextLimit] = useState(announcementData[indexValue]?.text.length);
  const [errors, setErrors] = useState({});
  const [publishHasOpen, setPublishHasOpen] = useState(false);
  useEffect((index) => {
    setSelectedTerminalsName(announcementData[indexValue]?.ports.map(name =>
      name.portName
    ).join(", "));
    setExpiryDateHours(hours);
    setExpiryDateMinutes(minute);
    ApiCall(
      'GET',
      utilityBaseURL + ALLPORTTERMINALS_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-cc-trace-id': '1234',
      },
    ).then((data) => {
      if (data.flag !== -1) {
        if (data.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          setPortData(data);
          console.log(data, 'portdata', announcementData[indexValue])
          let tss = {}
          data.forEach((s) => {
            tss[s.portId] = false
          })
          announcementData[indexValue].ports.forEach(a => {
            tss[a.portId] = true;
          });
          setTerminalSelectStatus(tss);
          console.log(tss, terminalSelectStatus, 'line 302;')
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }, [])
  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setShowEffectiveCalendar(false);
      setShowExpiryCalendar(false);
      setDropDownEffectiveHour(false);
      setDropDownExpiryHour(false);
      setDropDownEffectiveMinute(false);
      setDropDownExpiryMinute(false);
      setTerminalDropDown(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  const getSelectedTerminals = () => {
    let selectedTerminals = [];
    Object.keys(terminalSelectStatus).map((val, key) => {
      if (terminalSelectStatus[val]) {
        selectedTerminals.push({
          portId: portData[key]?.portId,
          portName: portData[key]?.portName,
          portType: portData[key]?.portType,
          portCode: portData[key]?.portCode,
          integratedWith: portData[key].integratedWith,
          portFromDate: portData[key].portFromDate,
          portToDate: portData[key].portToDate,
          weatherUrl: portData[key].weatherUrl
        });
      }
    })
    console.log("shdhfgdhfgdfd", selectedTerminals);
    return selectedTerminals;
  };
  const handleSubmit = () => {
    if (handleValidation()) {
      getPublish();
    }
  }
  const handleValidation = () => {
    let ExpiryDate = expiryDate.length != 0 ? new Date(Number(expiryDate)).getDate() : new Date(Number(calendarTwoCopy)).getDate()
    let fromDate = effectiveDate.length != 0 ? new Date(Number(effectiveDate)).getDate() : (new Date(Number(calendarOneCopy))).getDate()
    let toMonth = expiryDate.length != 0 ? new Date(Number(expiryDate)).getMonth() : (new Date(Number(calendarTwoCopy))).getMonth()
    let fromMonth = effectiveDate.length != 0 ? new Date(Number(effectiveDate)).getMonth() : (new Date(Number(calendarOneCopy))).getMonth()
    let toYear = expiryDate.length != 0 ? new Date(Number(expiryDate)).getFullYear() : (new Date(Number(calendarTwoCopy))).getFullYear()
    let fromYear = effectiveDate.length != 0 ? new Date(Number(effectiveDate)).getFullYear() : (new Date(Number(calendarOneCopy))).getFullYear()
    let error = {};
    let formIsValid = true;
    let patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
    if (!patternCharacter.test(aCategory)) {
      formIsValid = false;
      error["announcementName"] = message.validation.alpha;
    }
    if (fromYear > toYear) {
      formIsValid = false;
      error["todate"] = message.validation.dateTime;
    }
    else if (fromYear === toYear) {
      if (fromMonth > toMonth) {
        formIsValid = false;
        error["todate"] = message.validation.dateTime;
      }
      else if (fromMonth === toMonth) {
        if (fromDate > ExpiryDate) {
          formIsValid = false;
          error["todate"] = message.validation.dateTime;
        }
        else if (fromDate == ExpiryDate) {
          console.log("cal", effectiveDate, expiryDate)
          if (effectiveDateHourValue > expiryDateHourValue) {
            formIsValid = false;
            error["todate"] = message.validation.dateTime;
          }
          else if (effectiveDateHourValue == expiryDateHourValue) {
            if (effectiveDateMinuteValue > expiryDateMinuteValue) {
              formIsValid = false;
              error["todate"] = message.validation.dateTime;
            }
          }
        }
      }
    }
    setErrors(error);
    return formIsValid;
  }
  const toggleEffectiveCalendar = () => {
    setShowEffectiveCalendar(!showEffectiveCalendar);
  }
  const toggleExpiryCalendar = () => {
    setShowExpiryCalendar(!showExpiryCalendar);
  }
  const handlePdfUploadLink = (imagePathURL) => {
    setPdfUploadLink(imagePathURL);
  }
  const removePdfUploadedLink = () => {
    let path = "";
    setPdfUploadLink(path)
  }
  //formDate
  const handleEffectiveDateChanged = (e) => {
    setEffectiveDateValue(getDateEdit(e));
    setEffectiveDate(new Date(Number(e)));
    setShowEffectiveCalendar(false);
    setErrors({ ...errors, todate: '' });
  }
  const changeEffectiveHour = (event) => {
    const found = hours.find((name) => {
      if (name.hour === event.target.innerText) {
        return name;
      }
    })
    setEffectiveDateHourValue(found.hour);
    setDropDownEffectiveHour(false);
    setErrors({ ...errors, todate: '' });
  };
  const changeEffectiveMinute = (event) => {
    const found = minute.find((name) => {
      if (name.m === event.target.innerText) {
        return name;
      }
    })
    setEffectiveDateMinuteValue(found.m);
    setDropDownEffectiveMinute(false);
    setErrors({ ...errors, todate: '' });
  };
  //toDate
  const handleExpiryDateChanged = (e) => {
    setExpiryDateValue(getDateEdit(e));
    setExpiryDate(new Date(Number(e)))
    setErrors({ ...errors, todate: '' });
    setShowExpiryCalendar(false);
    let found = hours.filter((name) => {
      if (effectiveDateValue === getDateEdit(e)) {
        if (parseInt(name.hour) >= parseInt(effectiveDateHourValue)) {
          return true;
        }
      }
      if (effectiveDateValue !== getDateEdit(e)) {
        return true;
      }
    })
    setExpiryDateHours(found)
  }
  const changeExpiryHour = (event) => {
    const found = hours.find((name) => {
      if (name.hour === event.target.innerText) {
        return name;
      }
    })
    setExpiryDateHourValue(found.hour);
    setDropDownExpiryHour(false);
    setErrors({ ...errors, todate: '' });
    let found1 = minute.filter((name) => {
      if (effectiveDateValue === expiryDateValue) {
        if (parseInt(found.hour) === parseInt(effectiveDateHourValue)) {
          if (parseInt(name.m) > parseInt(effectiveDateMinuteValue)) {
            console.log('success');
            return true;
          }
        }
        if (parseInt(found.hour) !== parseInt(effectiveDateHourValue)) {
          return true;
        }
      }
      if (effectiveDateValue !== expiryDateValue) {
        return true;
      }
    })
    setExpiryDateMinutes(found1)
  };
  const changeExpiryMinute = (event) => {
    const found = minute.find((name) => {
      if (name.m === event.target.innerText) {
        return name;
      }
    })
    setExpiryDateMinuteValue(found.m);
    setDropDownExpiryMinute(false);
    setErrors({ ...errors, todate: '' });
  };
  const validateFormFields = () => {
    console.log("hi",terminalSelectStatus, Object.values(terminalSelectStatus).includes(true))
    if ((aCategory === "" || textmessage === "") && (aCategory === "" || pdfUploadLink === "")) {
      return true
    }
  };
  const toggleEffectiveHourDropdown = () => {
    setDropDownEffectiveHour(!dropDownEffectiveHour);
  };
  const toggleEffectiveMinuteDropdown = () => {
    setDropDownEffectiveMinute(!dropDownEffectiveMinute);
  };
  const toggleExpiryHourDropdown = () => {
    setDropDownExpiryHour(!dropDownExpiryHour);
  };
  const toggleExpiryMinuteDropdown = () => {
    setDropDownExpiryMinute(!dropDownExpiryMinute);
  };
  const toggleDropdown = () => {
    setTerminalDropDown(!terminalDropDown);
  }
  const handleCategory = (e) => {
    if (e.target.value.length <= 25) {
      setACategory(e.target.value);
    }
    setErrors({ ...errors, announcementName: '' });
    console.log("length", aCategory.length);
    console.log("xx", effectiveDateHourValue, expiryDateHourValue, effectiveDateMinuteValue, expiryDateMinuteValue)
  }
  const handleText = (e) => {
    setTextmessage(e.target.value);
    if (e.target.value.length <= 500) {
      setTextmessage(e.target.value);
      setTextLimit(e.target.value.length);
    }
  }
  const onPublish = () => {
    setPublishHasOpen(false);
    props.onClosePublish()
  }
  const getPublish = () => {
    let fromTimeStamp = effectiveDateValue.toString() + ' ' + effectiveDateHourValue + ':' + effectiveDateMinuteValue;
    let toTimeStamp = expiryDateValue.toString() + ' ' + expiryDateHourValue + ':' + expiryDateMinuteValue;
    //api call put
    ApiCall(
      'PUT',
      utilityBaseURL + UPDATEANNOUNCEMENT_ENDPOINT,
      {
        "announcementCategory": aCategory,
        "announcementFrom": Date.parse(fromTimeStamp),
        "announcementId": announcementData[indexValue]?.announcementId,
        "announcementTo": Date.parse(toTimeStamp),
        "attachment": pdfUploadLink,
        "ports": checked ? getSelectedTerminals() : selectedTerminal,

        "publishTime": publishDateTime.getTime(),
        "text": textmessage,
      },
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-cc-trace-id': '1234',
      }
    ).then(data => {
      if (data.flag !== -1) {
        if (data.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          setPublishHasOpen(true)
        }
      }
      else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    })
  }
  return (
    <div>
      <MetaDecorator title={TitleDescription.announcementEditModelPageTitle} description={TitleDescription.announcementEditModelPageDescription} />
      {indexValue !== null &&
        <div class="announcementModalOuter" >
          <div class="announcementModalInner">
            <div className='cross'>
              <img src={cross} width="21" height="21" onClick={props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
            </div>
            <div class="upperdiv">
              <small class="announcementModalTitle">
                Edit Announcement
            </small>
            </div>
            <div class="lowerdiv" >
              <div class="lowerInner">
                <div class="lowerSubInner">
                  <div class="leftPart">
                    <div>
                      <small class="announcementFieldsTitle">Terminals</small>
                      <div class="terminalsContainer">
                        <div class="terminalsField">
                          {!checked ?
                            <div class="announcementTooltip">
                              <small class="selectedTerminals">{selectedTerminalsName}</small>
                              <div class="announcementTooltipOuter">
                                <span class="announcementTooltopTextContainer">
                                  <div class="terminalsTooltip">
                                    <div class="terminalsTooltipInner">
                                      <small class="terminalsTooltipText">
                                        {selectedTerminalsName}
                                      </small>
                                    </div>
                                  </div>
                                </span>
                              </div>
                            </div>
                            :
                            <div class="announcementTooltip">
                              <small class="selectedTerminals">{getSelectedTerminals().map((val, key) => (
                                val.portName.split(':')[0]
                              )).join(', ')}
                              </small>
                              <div class="announcementTooltipOuter">
                                <span class="announcementTooltopTextContainer">
                                  <div class="terminalsTooltip">
                                    <div class="terminalsTooltipInner">
                                      <small class="terminalsTooltipText">
                                        {getSelectedTerminals().map((val, key) => (
                                          val.portName.split(':')[0]
                                        )).join(', ')}
                                      </small>
                                    </div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          }
                          <img class="terminalDropdown" onClick={toggleDropdown} src={arrow} alt="Second slide" />
                        </div>
                        {terminalDropDown && (
                          <div class="terminalDropdownContainer">
                            <div class="border" id="terminaldDropdownOuter" ref={container} style={{ top: '27px' }}>
                              <dl style={{ marginBottom: "0.1rem" }}>
                                <dt>
                                  <small class="p-1" id="terminalData">
                                    <img src={selectAll ?
                                      require('../../../assets/images/checkedBox.svg') :
                                      require('../../../assets/images/uncheckedBox.svg')
                                    }
                                      width="32"
                                      height="32"
                                      class="d-inline-block pl-2 pr-2"
                                      onClick={() => {
                                        let a = terminalSelectStatus;
                                        Object.keys(a).forEach(k => {
                                          a[k] = !selectAll
                                        })
                                        setTerminalSelectStatus(a);
                                        console.log(terminalSelectStatus)
                                        setSelectAll(!selectAll);
                                        setChecked(true);
                                      }
                                      }
                                    />
                                Select All
                              </small>
                                </dt>
                                {portData.map((data, index) => {
                                  return (
                                    <dt key={index}>
                                      <small class="p-1" id="terminalData">
                                        <img
                                          src={terminalSelectStatus[data.portId] ?
                                            require('../../../assets/images/checkedBox.svg') :
                                            require('../../../assets/images/uncheckedBox.svg')
                                          }
                                          width="32"
                                          height="32"
                                          class="d-inline-block pl-2 pr-2"
                                          onClick={() => {
                                            let a = terminalSelectStatus;
                                            a[data.portId] = !a[data.portId];
                                            setSelectAll(false);
                                            setTerminalSelectStatus(a);
                                            setChecked(true);
                                            console.log(a)
                                          }}
                                        />
                                        {data.portName.split(':')[0]}
                                      </small>
                                    </dt>
                                  )
                                }
                                )}
                              </dl>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div class="announcementEffectiveContainer">
                      <small class="announcementFieldsTitle">Effective Date & Time</small>
                      <div class="announcementDateRow">
                        <div class="announcementDateInput">
                          <input class="announcementInputBox" placeholder="DD/MM/YYYY" value={effectiveDateValue}></input>
                        </div>
                        <div class="announcementCalender">  {showEffectiveCalendar ? <div ref={container}> <Calendar onChange={handleEffectiveDateChanged} minDate={new Date()} /></div> : null}</div>
                        <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1" alt="" loading="lazy" alt="" onClick={toggleEffectiveCalendar}
                        />
                        <div class="hourMinuteDiv">
                          <input class="announcementInputBox" value={effectiveDateHourValue} placeholder="HH"></input>
                        </div>
                        <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={toggleEffectiveHourDropdown} />
                        <div>
                          {dropDownEffectiveHour && (
                            <div class="border" id="announcementHourDropdown" ref={container} >
                              {hours.map((datah, indexh) => {
                                return (
                                  <table class="announcementHourHover">
                                    <tr onClick={(index1) => changeEffectiveHour(index1)}>
                                      <small class="hourMinuteText">{datah.hour}</small>
                                    </tr>
                                  </table>
                                )
                              }
                              )}
                            </div>
                          )}</div>
                        <div class="hourMinuteDiv">
                          <input class="announcementInputBox" value={effectiveDateMinuteValue} placeholder="MM"></input>
                        </div>
                        <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={toggleEffectiveMinuteDropdown} />
                        <div>
                          {dropDownEffectiveMinute && (
                            <div class="border" id="announcementMinuteDropdown" ref={container} >
                              {minute.map((datam, indexh) => {
                                return (
                                  <table class="announcementHourHover">
                                    <tr onClick={(index1) => changeEffectiveMinute(index1)}>
                                      <small class="hourMinuteText">{datam.m}</small>
                                    </tr>
                                  </table>
                                )
                              }
                              )}
                            </div>
                          )}</div>
                      </div>
                      <div className="errordateTime">{errors["todate"]}</div>
                    </div>
                    <div class="announcementUploadContainer">
                      <div class="announcementUploadTitle">
                        <small class="announcementFieldsTitle">Upload PDF for Announcement</small>
                      </div>
                      <div class="announcementUploadPdf">
                        <Upload setImageLink={handlePdfUploadLink} pdfFileName={pdfLink} isUploadDisabled={isUploadDisabled} removeLink={removePdfUploadedLink}></Upload>
                      </div>
                    </div>
                  </div>
                  <div class="rightPart">
                    <div class="announcementCategoryContainer">
                      <small class="announcementFieldsTitle">Announcement Category</small>
                      <input class="announcementInputBox" value={aCategory} onChange={handleCategory} placeholder="Enter category"></input>
                      <div className="announcementCategoryError">{errors["announcementName"]}</div>
                    </div>
                    <div class="announcementExpiryContainer">
                      <small class="announcementFieldsTitle">Expiry Date & Time</small>
                      <div class="announcementDateRow">
                        <div class="announcementDateInput">
                          <input class="announcementInputBox" placeholder="DD/MM/YYYY" value={expiryDateValue}></input>
                        </div>
                        <div class="announcementCalender">  {showExpiryCalendar ? <div ref={container}> <Calendar onChange={handleExpiryDateChanged} minDate={effectiveDate.length != 0 ? new Date(Number(effectiveDate)) : (new Date() > new Date(Number(calendarOneCopy)) ? new Date() : new Date(Number(calendarOneCopy)))} /></div> : null}</div>
                        <img id="ppinput_img2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1" alt="" loading="lazy" alt="" onClick={toggleExpiryCalendar}
                        />
                        <div class="hourMinuteDiv">
                          <input class="announcementInputBox" value={expiryDateHourValue} placeholder="HH"></input>
                        </div>
                        <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={toggleExpiryHourDropdown} />
                        <div>
                          {dropDownExpiryHour && (
                            <div class="border" id="announcementHourDropdown" ref={container} >
                              {expiryDateHours.map((datah, indexh) => {
                                return (
                                  <table class="announcementHourHover">
                                    <tr onClick={(index1) => changeExpiryHour(index1)}>
                                      <small class="hourMinuteText">{datah.hour}</small>
                                    </tr>
                                  </table>
                                )
                              }
                              )}
                            </div>
                          )}</div>
                        <div class="hourMinuteDiv">
                          <input class="announcementInputBox" value={expiryDateMinuteValue} placeholder="MM"></input>
                        </div>
                        <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={toggleExpiryMinuteDropdown} />
                        <div>
                          {dropDownExpiryMinute && (
                            <div class="border" id="announcementMinuteDropdown" ref={container} >
                              {expiryDateMinutes.map((datam, indexh) => {
                                return (
                                  <table class="announcementHourHover">
                                    <tr onClick={(index1) => changeExpiryMinute(index1)}>
                                      <small class="hourMinuteText">{datam.m}</small>
                                    </tr>
                                  </table>
                                )
                              }
                              )}
                            </div>
                          )}</div>
                      </div>
                    </div>
                    <div class="announcementMessageContainer">
                      <small class="announcementFieldsTitle">Text Message for Announcement </small>
                      <textarea class="announcementTextarea" onChange={handleText} value={textmessage}></textarea>
                      <small class="announcementTextLimit">{textLimit}/500</small>
                    </div>
                    <div class="announcementPublishContainer">
                      <button class="announcementPublishButton" disabled={validateFormFields()}><small class="announcementPublishText" onClick={handleSubmit}
                      >Publish</small></button>
                    </div>
                  </div>
                  {/* note */}
                  <div>
                    <p className="announcementNote"><b className="note">Note:</b> Announcement can be published as Text, PDF or both</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SubmitModal onClick={onPublish} hasOpen={publishHasOpen} >
            <div className="sectionTextContainer">
              <p className="sectionText">Your announcement has been published successfully</p>
            </div>
          </SubmitModal>
        </div>
      }
    </div>
  );
};
export default EditModal;